import { GetApiIntroducerPortalIntroducerApplicationDocumentFeedbackResponse } from '@iwoca/lapi-client/introducer_portal';
import { t } from '@lingui/core/macro';

export const getAdditionalInfoMessage = (
  type: GetApiIntroducerPortalIntroducerApplicationDocumentFeedbackResponse['data']['additional_info_requests'][number]['request_type'],
): { label: string; description: string } | null => {
  switch (type) {
    case 'LOAN_PURPOSE':
      return {
        label: t`Loan purpose`,
        description: t`Please provide us with a brief explanation of the purpose of the loan.`,
      };
    case 'DATE_OF_FOUNDATION':
      return {
        label: t`Date of foundation`,
        description: t`Please send us a confirmation of the company's founding date or alternatively upload the trade licence (under "Other documents").`,
      };
    case 'TRADE_LICENSE':
      return {
        label: t`Trade licence`,
        description: t`Please send us the trade licence or alternatively upload it (under "Other documents").`,
      };
    case 'LEGAL_FORM':
      return {
        label: t`Legal form`,
        description: t`Please provide us with a brief explanation of the legal form or alternatively upload the trade licence (under "Other documents").`,
      };
    case 'NO_ACCOUNT_NUMBER':
      return {
        label: t`Missing Statements`,
        description: t`Please upload bank statements for the last 90 days in PDF format (under "Bank Statements"). Make sure they include the balances and all transactions. We require statements for all accounts that process more than 10% of the total business revenue.`,
      };
    case 'ADG':
    case 'CHECK_OPTIONAL_ADG':
      return null;
    default:
      return null;
  }
};
